import { render } from "./ListNews.vue?vue&type=template&id=4c7dbd5e"
import script from "./ListNews.vue?vue&type=script&lang=js"
export * from "./ListNews.vue?vue&type=script&lang=js"

import "./ListNews.vue?vue&type=style&index=0&id=4c7dbd5e&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__